import * as restfulService from '../../../services/restfulService'
import store from '../../../../vuex'

export const buscarContratos = () => {
  return new Promise((resolve, reject) => {
    let data = {ref_pessoa: store.getters.currentUser.ref_pessoa, orderBy: [{column: 'id'}]}
    restfulService.search('contrato', null, data, ['id', 'ref_pessoa', 'ref_curriculo'], ['curriculo'])
      .then((response) => {
        response.data.forEach(item => {
          item.descricao = item.ref_curriculo + ' - ' + item.curriculo.descricao + (item.curriculo.dt_extincao ? ' (Inativo)' : '')
        })
        resolve(response.data)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const buscarTurmasAlunoEnsinoBasico = () => {
  return new Promise((resolve, reject) => {
    restfulService.get('contrato', 'turmas-aluno-ensino-basico')
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const buscarPeriodos = (refContrato) => {
  return new Promise((resolve, reject) => {
    restfulService.get('contrato', 'periodos', refContrato)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const buscarPeriodosAtivos = (refContrato) => {
  return new Promise((resolve, reject) => {
    restfulService.get('contrato', 'periodos-ativos', refContrato)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}



// WEBPACK FOOTER //
// ./src/app/domains/academico/services/contratoService.js